import {
  keepPreviousData,
  MutationObserverOptions,
  QueryObserverOptions,
} from '@tanstack/react-query';
import {IS_CLIENT_SIDE} from '../common/shared/utils/constants';

export const QUERY_DEFAULT_OPTION: Omit<QueryObserverOptions, 'queryKey'> = {
  throwOnError: true,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchInterval: false,
  refetchIntervalInBackground: false,
  gcTime: 0,
  retry: false,
  placeholderData: keepPreviousData,
  /**
   * react-query는 online을 기본 모드로 사용합니다.
   * 이 모드는 offline 되면 query 요청을 하지 않습니다.
   * 참고로 aos에서는 위 동작이 잘 되고 있는데 ios만 되지 않습니다. (navigator.onLine을 사용하는데 이 값이 정확하지 않다는 글을 본 기억이..)
   * https://github.com/TanStack/query/blob/3f22c3d249000d56efe30ffa4fe14101b57bdd69/packages/query-core/src/onlineManager.ts#L86
   *
   * 페이지 웹에서는 offline 이더라도 query 요청을 하여 네트워크 에러 발생시 적절한 에러 페이지를 보여줘야하기 때문에 always로 변경합니다.
   */
  networkMode: 'always',
};

export const MUTATION_DEFAULT_OPTION: MutationObserverOptions = {
  retry: false,
  networkMode: 'always',
};

/** react-query의 (cache, stale)time에 Infinity를 설정할 수 있습니다.
 *  SSR 환경에서 이 값을 stringify할 때 유효한 값이 아니라 null이 전달되기 때문에 아래와 같이 값을 추가합니다.
 *  365일은 TimeoutOverflowWarning 이 뜨고 있어 24시간으로 설정합니다 */
export const REACT_QUERY_INFINITY_TIME = 1000 * 60 * 60 * 24;
/**
 * 쿼리에 대한 캐시된 값이 있다면 캐시된 값을 사용하는 옵션입니다.
 * 이 값은 getInitialProps, getServerSideProps 등에서 getDehydrateState 를 통해 옵션도 SSR -> CSR 로 넘어갑니다
 */
export const CACHE_ONLY_CONFIG = {
  gcTime: IS_CLIENT_SIDE ? Infinity : REACT_QUERY_INFINITY_TIME,
  staleTime: IS_CLIENT_SIDE ? Infinity : REACT_QUERY_INFINITY_TIME,
};

export const ONLY_DATA_CONFIG = {
  throwOnError: false,
  enabled: false,
};
